<div class="container_dati_generali">

  <table class="fondo_rischi">
    <caption class="sr-only">Tabella danni</caption>
    <tr class="selected_second_level">
      <td>Valori personalizzazione danno</td>
      <td>
        <a href="#" onclick="return false;" (click)="onOpenModificaDati()">Modifica
          dati<span class="glyphicon glyphicon-pencil"></span></a>
      </td>
    </tr>
    <ng-template [ngIf]="dannoBiologico">
    <tr class="borded">
      <td>Patologia</td>
      <td>{{dannoBiologico.patologia ? dannoBiologico.patologia : ''}}</td>
    </tr>
    <tr class="borded">
      <td>Data diagnosi</td>
      <td>{{(dannoBiologico.dataDiagnosi ? dannoBiologico.dataDiagnosi : '') | date:'dd/MM/yyyy'}}</td>
    </tr>
    <tr class="borded">
      <td>Data decesso</td>
      <td>{{(dannoBiologico.dataDecesso ? dannoBiologico.dataDecesso : '') | date:'dd/MM/yyyy'}}</td>
    </tr>
    <tr class="borded">
      <td>Riconoscimento di malattia professionale</td>
      <td>{{dannoBiologico.riconoscimentoMalattiaProfessionale ? 'Si' : 'No'}}</td>
    </tr>
    <tr class="borded">
      <td>Data riconoscimento di malattia professionale</td>
      <td>{{(dannoBiologico.dataRiconoscimentoMalattiaProfessionale ? dannoBiologico.dataRiconoscimentoMalattiaProfessionale : '')  | date: 'dd/MM/yyyy'}}</td>
    </tr>
    <tr class="borded">
      <td>% invalidità</td>
      <td>{{dannoBiologico.percentualeInvalidita ? dannoBiologico.percentualeInvalidita + '%' : ''}}</td>
    </tr>
    <tr class="borded">
      <td>Numero giorni di invalidità temporanea</td>
      <td>{{'10'}}</td>
    </tr>
    <tr class="borded">
      <td>Data rilevazione di invalidità temporanea</td>
      <td>{{(dannoBiologico.dataRilevazioneInvaliditaTemp ? dannoBiologico.dataRilevazioneInvaliditaTemp : '') | date: 'dd/MM/yyyy'}}</td>
    </tr>
    <tr class="borded">
      <td>Note</td>
      <td>{{dannoBiologico.note ? dannoBiologico.note : ''}}</td>
    </tr>
    <tr class="borded">
      <td>Danno biologico</td>
      <td>{{(dannoBiologico.importoDannoBiologico ? dannoBiologico.importoDannoBiologico : 0) | euro}}&euro;</td>
    </tr>
    <tr class="borded">
      <td>Danno morale</td>
      <td>{{(dannoBiologico.importoDannoMorale ? dannoBiologico.importoDannoMorale : 0) | euro}}&euro;</td>
    </tr>
    <tr class="borded">
      <td>Danno morale eredi/congiunti</td>
      <td>{{(dannoBiologico.importoDannoMoraleEredi ? dannoBiologico.importoDannoMoraleEredi : 0) | euro}}&euro;</td>
    </tr>
    <tr class="borded">
      <td>Data rilevazione di invalidità temporanea</td>
      <td>{{(dannoBiologico.dataRilevazioneInvaliditaTemp ? dannoBiologico.dataRilevazioneInvaliditaTemp :'') | date:'dd/MM/yyyy'}}</td>
    </tr>
    <tr class="borded">
      <td>Invalidità temporanea</td>
      <td>{{(dannoBiologico.importoInvaliditaTemp ? dannoBiologico.importoInvaliditaTemp : 0) | euro}}&euro;</td>
    </tr>
    <tr class="borded" style="color: #0b59a4; font-weight: bold;">
      <td>Totale pre-abbattimento</td>
      <td>{{(dannoBiologico.totalePreabbattimento ? dannoBiologico.totalePreabbattimento : 0) | euro}}&euro;</td>
    </tr>
    <tr class="selected_second_level" style = "border-bottom: none; border-top: 1px solid #4b8ac180">
      <td>% abbattimento</td>
      <td>{{dannoBiologico.percentualeAbbattimento ? dannoBiologico.percentualeAbbattimento + '%' : '' }}
      </td>
    </tr>
    <tr class="selected_second_level">
      <td>Totale</td>
      <td>{{(dannoBiologico.totale ? dannoBiologico.totale : 0) | euro }} &euro;
      </td>
    </tr>
  </ng-template>
  </table>
</div>